
<v-menu
    v-model="show"
    :position-x ="68"
    :position-y="272"
    absolute
    offset-y
    nudge-top="-4"
    min-width="250"
    @input  = "onInput"
>
    <div class="history-title primary white--text">
       {{ $t('unit.tzb.reports') }}
    </div>
    <v-list>
        <v-list-item
            v-for  = "(item, index) in menu"
            :key   = "index"
            @click = "onSelected(item)"
        >
            <div class="v-flex">
                <div >
                    {{ item.name }}
                </div>
            </div>
        </v-list-item>
    </v-list>
</v-menu>
